import React from 'react';
import { Link } from 'react-router-dom';

const BackButton = () => {
  return (
    <div className="row">
      <div className="col-lg-2">
        <Link
          to="/"
          className="btn btn-outline-green-1 form-control"
          tabIndex={7}
        >
          Back
        </Link>
      </div>
    </div>
  );
};

export default BackButton;
